/* Built In Imports */

/* External Imports */
import { Box } from "@chakra-ui/react";

/* Internal Imports */
import SectionTitle from '@components/Headings/SectionTitle';
import TopKolam from '@components/Headings/TopKolam';
import ApplyStep from '@landing_pages/hytt/components/ApplyStep';
import config from '@config';

/* Services */

const HowtoApply = ({ sectionContent, region, lang, section }) => {
    return (
        <Box marginTop="0px">
            <Box mb="10px">
                <SectionTitle
                    titleObj={sectionContent[0]}
                    titleDecoration={sectionContent[0]?.titleDecoration}
                    mx={{ base: '17px', md: 'auto' }}
                    fontSize={{ base: "30px", sm: "30px", md: "" }}
                    color={'#ffffff'}
                />
                <Box marginTop={"-30px"}>
                    <TopKolam
                        sectionContent={sectionContent[1]}
                    />
                </Box>
                <Box 
                    width={{base:'90%', md:'720px'}} 
                    m="0 auto"
                    backgroundImage={{
                        base: `${config.imgPath}/d/46272/1712840772-howtoapply_steps_mobile1.png`,
                        md: section?.styleConfig?.bgImage?.url,
                      }}
                    backgroundRepeat={{base:'no-repeat', lg:'repeat-y'}} 
                    backgroundPosition={{base:'top center', md:'top center'}}
                    backgroundSize={{base:'cover', md:'contain'}}
                    // height={{base:'2250px'}}
                >
                    {sectionContent[2]?.cards.map((card, index) => {
                        const isEvenIndex = index % 2 === 0;
                        const alignDirection = isEvenIndex ? 'flex-start' : 'flex-end';
                        const margnleft = isEvenIndex ? '0px' : 'auto';
                            return (
                                <ApplyStep card={card} index={index} btn={sectionContent[3]} region={region} lang={lang} bgcolor={section?.styleConfig?.bgColour?.hex}/>
                            );
                        })}
                </Box>
            </Box>
            <style jsx global>
                {`
                    .step_icon img {
                        max-width: none;
                        width: 54px !important
                    }
                        
                `}
            </style>
        </Box>
    );
};

export default HowtoApply